import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, vShow as _vShow, normalizeStyle as _normalizeStyle, renderList as _renderList, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "list-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = { class: "filter-box" }
const _hoisted_4 = { class: "filter-box" }
const _hoisted_5 = { class: "filter-box" }
const _hoisted_6 = { class: "filter-box" }
const _hoisted_7 = { class: "filter-box" }
const _hoisted_8 = { class: "filter-box" }
const _hoisted_9 = { class: "filter-box" }
const _hoisted_10 = { class: "filter-box" }
const _hoisted_11 = { class: "split-table-layout" }
const _hoisted_12 = { class: "clearfix tab-title btn-container mt-10" }
const _hoisted_13 = { class: "tab-title_left fl" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_TableList = _resolveComponent("TableList")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_TableSplitter = _resolveComponent("TableSplitter")!
  const _component_BusinessInfo = _resolveComponent("BusinessInfo")!
  const _component_FormComponent = _resolveComponent("FormComponent")!
  const _component_PrintCom = _resolveComponent("PrintCom")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_waves = _resolveDirective("waves")!
  const _directive_permission = _resolveDirective("permission")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        (!_ctx.isFilterCollapse)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_3, [
                _cache[16] || (_cache[16] = _createElementVNode("span", { class: "label" }, "业务编号", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.businessNo,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.listQuery.businessNo) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: "",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                }, null, 8, ["modelValue", "size", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _cache[17] || (_cache[17] = _createElementVNode("span", { class: "label" }, "业务名称", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.businessName,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.listQuery.businessName) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: "",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                }, null, 8, ["modelValue", "size", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _cache[18] || (_cache[18] = _createElementVNode("span", { class: "label" }, "业务型号", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.businessModel,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.listQuery.businessModel) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: "",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                }, null, 8, ["modelValue", "size", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _cache[19] || (_cache[19] = _createElementVNode("span", { class: "label" }, "公司名称", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.customerCompany,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.listQuery.customerCompany) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: "",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                }, null, 8, ["modelValue", "size", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _cache[20] || (_cache[20] = _createElementVNode("span", { class: "label" }, "联系人", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.customerCompanyContact,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.listQuery.customerCompanyContact) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: "",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                }, null, 8, ["modelValue", "size", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _cache[21] || (_cache[21] = _createElementVNode("span", { class: "label" }, "报价日期", -1)),
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.listQuery.startTime,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.listQuery.startTime) = $event)),
                  type: "date",
                  placeholder: " ",
                  format: "YYYY-MM-DD",
                  "value-format": "YYYY-MM-DD",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"]),
                  size: _ctx.t('table.btnSize')
                }, null, 8, ["modelValue", "onKeyup", "size"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _cache[22] || (_cache[22] = _createElementVNode("span", { class: "label" }, "结束日期", -1)),
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.listQuery.endTime,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.listQuery.endTime) = $event)),
                  type: "date",
                  placeholder: " ",
                  format: "YYYY-MM-DD",
                  "value-format": "YYYY-MM-DD",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"]),
                  size: _ctx.t('table.btnSize')
                }, null, 8, ["modelValue", "onKeyup", "size"])
              ])
            ], 64))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_10, [
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            type: "primary",
            size: _ctx.t('table.btnSize'),
            onClick: _ctx.handleFilter
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.search")), 1)
            ]),
            _: 1
          }, 8, ["size", "onClick"])), [
            [_directive_waves]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            type: "primary",
            size: _ctx.t('table.btnSize'),
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.handleCommand('add')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.add")), 1)
            ]),
            _: 1
          }, 8, ["size"])), [
            [_directive_permission, { pkey: `${_ctx.permissionName}_ADD` }]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            size: _ctx.t('table.btnSize'),
            onClick: _ctx.handleReset
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.reset")), 1)
            ]),
            _: 1
          }, 8, ["size", "onClick"])), [
            [_directive_waves]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            size: _ctx.t('table.btnSize'),
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.isFilterCollapse = !_ctx.isFilterCollapse))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.isFilterCollapse ? '展开' : '收起'), 1)
            ]),
            _: 1
          }, 8, ["size"])), [
            [_directive_waves]
          ]),
          _createElementVNode("span", {
            class: "svg-icon cursor mr-10 ml-10",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.handleCommand('refresh')))
          }, [...(_cache[23] || (_cache[23] = [
            _createElementVNode("i", { class: "icon-tubiao-27 iconfont" }, null, -1)
          ]))]),
          _createElementVNode("span", {
            class: "svg-icon cursor",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.handleCommand('column')))
          }, [...(_cache[24] || (_cache[24] = [
            _createElementVNode("i", { class: "icon-tubiao-28 iconfont" }, null, -1)
          ]))])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", {
          class: "split-pane-top vue-grid-item",
          style: _normalizeStyle({ height: _ctx.isSubMenuCollapse ? '100%' : `${_ctx.topHeight}px` })
        }, [
          _withDirectives((_openBlock(), _createBlock(_component_TableList, {
            ref: el => { if (el) _ctx.tableListRef[0] = el },
            dataList: _ctx.list,
            total: _ctx.total,
            columnAllData: _ctx.columnAllData,
            tableName: _ctx.TableName,
            handleDefaultWidth: 120,
            permissionName: _ctx.permissionName,
            showSelection: true,
            showSummary: true,
            isShowPagination: false,
            highlightCurrentRow: true,
            layoutHeight: true,
            newHpx: _ctx.newHpx,
            style: {"height":"100%","overflow":"hidden"},
            onRowClick: _ctx.handleRowClick,
            onCommandChange: _ctx.handleCommand
          }, {
            "operation-action": _withCtx((scope) => [
              _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                href: "javascript:void(0);",
                class: "mr-10",
                type: "primary",
                onClick: ($event: any) => (_ctx.handleCommand('edit', scope.row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("table.edit")), 1)
                ]),
                _: 1
              }, 8, ["onClick"])), [
                [_directive_permission, { pkey: `${_ctx.permissionName}_EDIT` }]
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                href: "javascript:void(0);",
                class: "mr-10",
                type: "primary",
                onClick: ($event: any) => (_ctx.handleCommand('print', scope.row))
              }, {
                default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                  _createTextVNode(" 打印 ", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])), [
                [_directive_permission, { pkey: `${_ctx.permissionName}_PRINT` }]
              ])
            ]),
            _: 1
          }, 8, ["dataList", "total", "columnAllData", "tableName", "permissionName", "newHpx", "onRowClick", "onCommandChange"])), [
            [_directive_loading, _ctx.listLoading]
          ]),
          _withDirectives(_createVNode(_component_el_pagination, {
            class: "mt-20",
            total: _ctx.total,
            currentPage: _ctx.listQuery.page,
            "onUpdate:currentPage": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.listQuery.page) = $event)),
            "page-size": _ctx.listQuery.size,
            "page-sizes": _ctx.pageSizes,
            onSizeChange: _ctx.handleSizeChange,
            onCurrentChange: _ctx.handleCurrentChange,
            layout: "total, sizes, prev, pager, next"
          }, null, 8, ["total", "currentPage", "page-size", "page-sizes", "onSizeChange", "onCurrentChange"]), [
            [_vShow, _ctx.total > 0]
          ])
        ], 4),
        (!_ctx.isSubMenuCollapse && _ctx.tabList.length)
          ? (_openBlock(), _createBlock(_component_TableSplitter, {
              key: 0,
              onDragStart: _ctx.handleSplitterDragStart,
              onDragMove: _ctx.handleSplitterDragMove,
              onDragEnd: _ctx.handleSplitterDragEnd
            }, null, 8, ["onDragStart", "onDragMove", "onDragEnd"]))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("div", {
          class: "split-pane-bottom",
          style: _normalizeStyle({ height: `${_ctx.bottomHeight}px` })
        }, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("ul", _hoisted_13, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabList, (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: item.id,
                  class: _normalizeClass({ active: _ctx.activeTab === item.id }),
                  onClick: ($event: any) => (_ctx.handleTabClick(item))
                }, _toDisplayString(item.name), 11, _hoisted_14))
              }), 128))
            ])
          ]),
          (_ctx.activeTab === 2)
            ? (_openBlock(), _createBlock(_component_BusinessInfo, {
                key: 0,
                ref: "TraceInfo",
                id: _ctx.activeId,
                api: "quotation"
              }, null, 8, ["id"]))
            : _createCommentVNode("", true)
        ], 4), [
          [_vShow, !_ctx.isSubMenuCollapse && _ctx.tabList.length]
        ])
      ])
    ], 512), [
      [_vShow, !_ctx.dialogFormVisible]
    ]),
    (_ctx.dialogFormVisible)
      ? (_openBlock(), _createBlock(_component_FormComponent, {
          key: 0,
          id: _ctx.activeId,
          dialogFormVisible: _ctx.dialogFormVisible,
          api: 'quotation',
          handleResolveTempData: _ctx.handleResolveTempData,
          "onUpdate:visibel": _cache[12] || (_cache[12] = () => _ctx.dialogFormVisible = false),
          onSubmit: _cache[13] || (_cache[13] = ($event: any) => (_ctx.handleSubmit(_ctx.formData)))
        }, null, 8, ["id", "dialogFormVisible", "handleResolveTempData"]))
      : _createCommentVNode("", true),
    (!_ctx.dialogFormVisible)
      ? (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          type: "primary",
          circle: "",
          onClick: _ctx.handleSubMenuCollapse,
          class: "subMenuCollapseBtn"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.isSubMenuCollapse ? '展开' : '收起'), 1)
          ]),
          _: 1
        }, 8, ["onClick"]))
      : _createCommentVNode("", true),
    (_ctx.printVisible)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 2,
          modelValue: _ctx.printVisible,
          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.printVisible) = $event)),
          title: "打印预览",
          width: "80%",
          "append-to-body": ""
        }, {
          footer: _withCtx(() => [
            _createElementVNode("span", _hoisted_15, [
              _createVNode(_component_el_button, {
                onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.printVisible = false)),
                type: "danger"
              }, {
                default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                  _createTextVNode("取消", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_PrintCom, {
              ref: "PrintCom",
              id: _ctx.activeRow.id
            }, null, 8, ["id"])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ]))
}